import { cards } from '@constants/cards'
import { CREDIT_CARD } from '@constants/paymentMethods'
import { getCard } from '@helpers/getCard'
import { useStyles } from '@hooks/useStyles'
import { useCheckoutContext } from '@pages/Checkout/routes/contexts'
import { Image } from '@ui-kit'
import { Row } from 'simple-flexbox'

import styles from './CreditCardsImages.module.scss'

export const CreditCardImages = () => {
  const { formik } = useCheckoutContext()

  const { values } = formik

  const { paymentMethod, cardNumber } = values

  const matchedCard = getCard(cardNumber)

  const creditCardsImagesStyles = useStyles({
    [styles['credit-cards-images']]: true,
    [styles['credit-cards-images--is-selected']]: paymentMethod === CREDIT_CARD
  })

  const cardsToRender = matchedCard ? [matchedCard] : cards

  return (
    <Row className={creditCardsImagesStyles} horizontal='space-between'>
      {cardsToRender.map(({ image, name }) => (
        <Image key={name} src={image} width='35px' height='24px' />
      ))}
    </Row>
  )
}

CreditCardImages.displayName = 'CheckoutPaymentPaymentMethodCreditCardImages'
